import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@fontsource-variable/outfit';
import '@fontsource-variable/syne';
import '@mantine/notifications/styles.css';

import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';

import { ErrorBoundary } from './components/global/ErrorBoundary/ErrorBoundary.tsx';
import { router } from './router/router.tsx';
import { tanstackQueryClient } from './services/tanstackQueryClient.ts';
import { cssVariablesResolver, theme } from './theme.tsx';

// Older versions kept the sign-up password here until the email was verified.
try {
  localStorage.removeItem('tbrpw');
} catch {
  // Storage can be unavailable (private mode, blocked site data).
}

const rootElement = document.querySelector('#root');
if (!rootElement) {
  throw new Error('index.html has no #root element');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={tanstackQueryClient}>
        <MantineProvider cssVariablesResolver={cssVariablesResolver} theme={theme}>
          <Notifications />
          <RouterProvider router={router} />
        </MantineProvider>
        <ReactQueryDevtools />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
